/*
* Broadcast Theme - Custom JS
*/

(function() {

  function switchToVariantImage(imageSrc) {
    var filename = imageSrc.split('/files/')[1]?.split('?')[0];
    if (!filename) return;

    var allMedia = document.querySelectorAll('[data-media-id]');
    var target = null;

    allMedia.forEach(function(el) {
      var img = el.querySelector('img');
      if (img) {
        var imgSrc = img.getAttribute('src') || img.getAttribute('data-src') || '';
        if (imgSrc.includes(filename)) target = el;
      }
    });

    if (!target) return;

    if (target.classList.contains('product__thumb__link') || target.hasAttribute('data-thumb-link')) {
      target.click();
      return;
    }

    var targetMediaId = target.getAttribute('data-media-id');
    var thumbLink = document.querySelector('[data-thumb-link][data-media-id="' + targetMediaId + '"]');
    if (thumbLink) {
      thumbLink.click();
      return;
    }
  }

  function updateColorLabel(variantId, product) {
    var variant = product.variants.find(function(v) { return String(v.id) === variantId; });
    if (!variant) return;

    // Update each option label (data-option-value)
    var selectorWrappers = document.querySelectorAll('[data-option-position]');
    selectorWrappers.forEach(function(wrapper) {
      var position = parseInt(wrapper.getAttribute('data-option-position')) - 1;
      var label = wrapper.querySelector('[data-option-value]');
      if (label && variant.options[position] !== undefined) {
        label.textContent = variant.options[position];
      }

      // Also check the correct radio button
      var radioInputs = wrapper.querySelectorAll('input[data-single-option-selector]');
      radioInputs.forEach(function(input) {
        if (input.value === variant.options[position]) {
          input.checked = true;
        }
      });
    });
  }

  function initVariantImageSwitch() {
    document.querySelectorAll('input[name="id"]').forEach(function(input) {
      input.addEventListener('change', function() {
        var variantId = this.value;
        var productJson = document.querySelector('[data-product-json]');
        if (!productJson) return;

        try {
          var product = JSON.parse(productJson.textContent);
          var variant = product.variants.find(function(v) { return String(v.id) === variantId; });
          if (!variant) return;

          // Update color label
          updateColorLabel(variantId, product);

          // Switch image
          if (variant.featured_image) {
            switchToVariantImage(variant.featured_image.src);
          }
        } catch(e) { console.log('variant switch error:', e); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantImageSwitch);
  } else {
    initVariantImageSwitch();
  }

})();
